module.exports = "<div class=\"card\">\r\n  <div class=\"card-body\">\r\n    <spk-search-grid [list]=\"'SearchGridFormatTestSearchRow'\" title=\"Searches\" autoload=\"true\" defaultSortProperty=\"\" showSearch=\"true\" [cellLinks]=\"cellLinks\"></spk-search-grid>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/search-grid-format-example/search-grid-format-example.component.html
// module id = ./src/app/components/examples/search-grid-format-example/search-grid-format-example.component.html
// module chunks = main